"use strict";

var _taggedTemplateLiteral = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const styled_components_1 = __importDefault(require("styled-components"));
/**
 * A ConstrainedBox can be used to provide a component with a with a size that
 * will never exceed the provided minimum and maximum.
 *
 * NB: This component is inspired by, but not identical to the Flutter
 * equivalent.
 * @see https://api.flutter.dev/flutter/widgets/ConstrainedBox-class.html
 */


const ConstrainedBox = styled_components_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  min-width: ", ";\n  max-width: ", ";\n  min-height: ", ";\n  max-height: ", ";\n"])), props => props.width, props => props.height, props => props.minWidth, props => props.maxWidth, props => props.minHeight, props => props.maxHeight);
exports.default = ConstrainedBox;